import React from "react";

const bannerBackground = () => {
  return (
    <div className="banner-bg">
      <svg className="bg-cut" viewBox="0 0 100 100" preserveAspectRatio="none">
        <polygon points="70,0 0,100 100,100  " />
      </svg>
    </div>
  );
};

export default bannerBackground;
